const SocialAccount = `
  fragment SocialAccount on SocialAccount {
    platform
    urlOrHandle
  }
`
export default SocialAccount
